import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { showMutationError } from "utils/showMutationError";

export const useSendEmail = () => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async (emailData) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/patientemail/send`,
        emailData
      );
      return response.data;
    },
    onError: (error) => showMutationError(error, "Failed to send email"),
  });
};
